import React from 'react';
import { TextField } from '@mui/material';
import SmtpTlsSelect from './SmtpTlsSelect';

/**
 * Shared server + port + TLS row for IMAP/SMTP blocks in SmtpTab.
 */
export default function SmtpServerBasicsFields({
  formData,
  handleChangeField,
  serverLabel,
  serverField,
  portField,
  connectionField
}) {
  return (
    <>
      <TextField
        margin="dense"
        label={serverLabel}
        fullWidth
        value={formData[serverField]}
        onChange={(e) => handleChangeField(serverField, e.target.value)}
      />
      <TextField
        margin="dense"
        label="Port"
        type="number"
        fullWidth
        value={formData[portField]}
        onChange={(e) => handleChangeField(portField, e.target.value)}
      />
      <SmtpTlsSelect
        value={formData[connectionField]}
        onChange={(e) => handleChangeField(connectionField, e.target.value)}
      />
    </>
  );
}
